/**
 * La WineTech — Pôles sectoriels (5 pôles).
 * Décrivent l'activité/marché d'une entreprise.
 * À ne pas confondre avec les Catégories d'adhésion (tarification).
 */
export const POLES = [
  { id: "producteur", label: "Producteurs", emoji: "🍷", description: "Domaines, caves coopératives, maisons de négoce" },
  { id: "consommateur", label: "Consommateurs", emoji: "👤", description: "Communautés, médias grand public" },
  { id: "on_trade", label: "On-trade", emoji: "🍽️", description: "Cafés, hôtels, restaurants" },
  { id: "off_trade", label: "Off-trade", emoji: "🛒", description: "Cavistes, GMS, e-commerce" },
  { id: "logistique", label: "Logistique", emoji: "🚚", description: "Transport, stockage, supply chain" },
];

export const POLE_BY_ID = Object.fromEntries(POLES.map((p) => [p.id, p]));

export const poleLabel = (id) => POLE_BY_ID[id]?.label || id || "—";
export const poleEmoji = (id) => POLE_BY_ID[id]?.emoji || "•";
